import { PackageOpen } from 'lucide-react'
import { Card, EmptyState, MoneyValue } from '@shared/design-system/ui'
import type { TopProduct } from '../api/dashboard.contract'
import {
  productInfo,
  productMeta,
  productName,
  productRow,
  sectionHeader,
  sectionTitle,
} from './dashboard.css'

export type TopProductsProps = {
  products: TopProduct[]
}

export function TopProducts({ products }: TopProductsProps) {
  return (
    <Card padding="md">
      <div className={sectionHeader}>
        <span className={sectionTitle}>Top produtos</span>
      </div>
      {products.length === 0 ? (
        <EmptyState
          icon={<PackageOpen size={22} />}
          title="Sem produtos no período"
          description="Os produtos mais vendidos aparecem aqui."
        />
      ) : (
        <div>
          {products.map((product) => (
            <div key={product.id} className={productRow}>
              <div className={productInfo}>
                <div className={productName}>{product.name}</div>
                <div className={productMeta}>{product.salesCount} itens pagos</div>
              </div>
              <MoneyValue
                amount={product.revenue.amount}
                currency={product.revenue.currency}
                size="sm"
              />
            </div>
          ))}
        </div>
      )}
    </Card>
  )
}
